/**
 * This function calculate the width of a string based on its length
 * @param {String} text
 * @param {String} font
 */
const getTextWidth = (text, font = '14px -apple-system') => {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    if (!context) {
        return 100
    }
    context.font = font
    const metrics = context.measureText(text)
    const extractText = (node): string => {
        if (typeof node === 'string') return node;
        if (node == null || typeof node !== 'object') return '';
        return extractText(node?.props?.children) ?? '';
    };
    const defaultLength = extractText(text).toLowerCase() === 'date' ? 100 : 80
    return Math.round(metrics.width + defaultLength)
}

/**
 * This function calculates the width of each column based in all CELL VALUES
 * @param {Array} columns
 * @param {Array} source
 * @param {number} maxWidthPerCell
 */
export const calculateColumnsWidth = (
    columns: any[],
    source: any[],
    maxWidthPerCell = 500
) => {
    // const columnsParsed = JSON.parse(JSON.stringify(columns)) as any[]

    const columnsWithWidth = columns.map(column => {
        // If column already has a width set, preserve it as fixed width
        if (column.width !== undefined) {
            return Object.assign(column, {
                width: column.width,
                fixedWidth: true
            })
        }
        return Object.assign(column, {
            width: getTextWidth(column.title)
        })
    })

    source.map(entry => {
        columnsWithWidth.map((column, indexColumn) => {
            // Skip width calculation for columns with fixed width
            if (column.fixedWidth) {
                return
            }

            const columnWidth = column.width
            const cellValue = Object.values(entry)[indexColumn + 1]

            let cellWidth = getTextWidth(cellValue)

            if (cellWidth < columnWidth) {
                cellWidth = columnWidth
            }
            if (cellWidth > maxWidthPerCell) {
                cellWidth = maxWidthPerCell
            }
            columnsWithWidth[indexColumn].width = cellWidth
        })
    })

    let tableWidth = columnsWithWidth
        .map(column => column.width)
        .reduce((a, b) => {
            return a + b
        }, 0)

    // If there are 5 or fewer columns, distribute width equally among non-fixed columns
    if (columnsWithWidth.length <= 5) {
        const minTableWidth = 1200 // Minimum table width for better distribution

        if (tableWidth < minTableWidth) {
            // Calculate total fixed width
            const fixedWidth = columnsWithWidth
                .filter(col => col.fixedWidth)
                .reduce((sum, col) => sum + col.width, 0)

            // Count non-fixed columns
            const nonFixedColumns = columnsWithWidth.filter(col => !col.fixedWidth).length

            if (nonFixedColumns > 0) {
                // Distribute remaining width equally among non-fixed columns
                const remainingWidth = minTableWidth - fixedWidth
                const equalWidth = Math.floor(remainingWidth / nonFixedColumns)

                columnsWithWidth.forEach(column => {
                    if (!column.fixedWidth) {
                        column.width = equalWidth
                    }
                })

                tableWidth = minTableWidth
            }
        }
    }

    // console.log({
    //     columns: columnsWithWidth,
    //     source,
    //     tableWidth
    // })

    return {
        columns: columnsWithWidth,
        source,
        tableWidth
    }
}